const playButton = document.getElementById('playVid');
const modal = document.getElementById('videoModal');
const frame = document.getElementById('videoFrame');

if (playButton && modal && frame) {
  const videoUrl = playButton.getAttribute('data-embed-url');
  const embedUrl = videoUrl.replace('watch?v=', 'embed/') + '?autoplay=1';
  
  setTimeout(() => {
    frame.src = embedUrl;
    frame.style.display = 'none';
  }, 100);

  playButton.addEventListener('click', function () {
      modal.style.display = 'flex';
      frame.style.display = 'block';
      frame.src = embedUrl;
    });

  const closeButton = document.querySelector('.video-close');
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      modal.style.display = 'none';
      frame.src = '';
    });
  }

  window.addEventListener('click', function (event) {
    if (event.target === modal) {
      modal.style.display = 'none';
      frame.src = '';
    }
  });
}
